import { ColumnsFilter, DMSCapabilitiesTable } from "modules/DMSv3/Capabilities/components";
import "modules/DMSv3/Capabilities/DMSCapabilities.scss";

export const DMSCapabilities = () => (
  <div className="DMSCapabilities">
    <ColumnsFilter />
    <DMSCapabilitiesTable />
  </div>
);
